import React, { Component } from "react";
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import ImageBackground from "../common/imageBackground";
import RevenueCenters from "./RevenueCenters";
import ShoppingPopup from "./ShoppingPopup";
import SlideShow from "../common/slideShow";
import "./styles.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";

class Service1350 extends Component {
  /**************
   * Properties *
   **************/
  state = {
    currentPatient: this.props.currentPatient,
    orthoPatient: {
      medical: [
        require("./images/orthoPatient/1350_ItemSelection_Medical_step1.png"),
        require("./images/orthoPatient/1350_ItemSelection_Medical_step2.png"),
        require("./images/orthoPatient/1350_ItemSelection_Medical_step3.png"),
        require("./images/orthoPatient/1350_ItemSelection_Medical_step4.png"),
        require("./images/orthoPatient/1350_Cart_Medical_editHL.png"),
        require("./images/orthoPatient/1350_Cart_Medical_editPopup.png"),
        require("./images/orthoPatient/1350_Cart_Medical_purchaseHL.png"),
        require("./images/orthoPatient/1350_Cart_Medical_thanksPopup.png"),
      ],
      gift_shop: [
        require("./images/orthoPatient/1350_ItemSelection_GiftShop_step1.png"),
        require("./images/orthoPatient/1350_ItemSelection_GiftShop_step2.png"),
        require("./images/orthoPatient/1350_ItemSelection_GiftShop_step3.png"),
        require("./images/orthoPatient/1350_ItemSelection_GiftShop_step4.png"),
        require("./images/orthoPatient/1350_Cart_GiftShop_editHL.png"),
        require("./images/orthoPatient/1350_Cart_GiftShop_editPopup.png"),
        require("./images/orthoPatient/1350_Cart_GiftShop_purchaseHL.png"),
        require("./images/orthoPatient/1350_Cart_GiftShop_thanksPopup.png"),
      ],
    },
    chfPatient: {
      medical: [
        require("./images/chfPatient/1350_ItemSelection_Medical_step1.png"),
        require("./images/chfPatient/1350_ItemSelection_Medical_step2.png"),
        require("./images/chfPatient/1350_ItemSelection_Medical_step3.png"),
        require("./images/chfPatient/1350_ItemSelection_Medical_step4.png"),
        require("./images/chfPatient/1350_Cart_Medical_editHL.png"),
        require("./images/chfPatient/1350_Cart_Medical_editPopup.png"),
        require("./images/chfPatient/1350_Cart_Medical_purchaseHL.png"),
        require("./images/chfPatient/1350_Cart_Medical_thanksPopup.png"),
      ],
      gift_shop: [
        require("./images/chfPatient/1350_ItemSelection_GiftShop_step1.png"),
        require("./images/chfPatient/1350_ItemSelection_GiftShop_step2.png"),
        require("./images/chfPatient/1350_ItemSelection_GiftShop_step3.png"),
        require("./images/chfPatient/1350_ItemSelection_GiftShop_step4.png"),
        require("./images/chfPatient/1350_Cart_GiftShop_editHL.png"),
        require("./images/chfPatient/1350_Cart_GiftShop_editPopup.png"),
        require("./images/chfPatient/1350_Cart_GiftShop_purchaseHL.png"),
        require("./images/chfPatient/1350_Cart_GiftShop_thanksPopup.png"),
      ],
    },
    pediatricPatient: {
      medical: [
        require("./images/pediatricPatient/1350_ItemSelection_Medical_step1.png"),
        require("./images/pediatricPatient/1350_Cart_Medical_editHL.png"),
        require("./images/pediatricPatient/1350_Cart_Medical_editPopup.png"),
        require("./images/pediatricPatient/1350_Cart_Medical_purchaseHL.png"),
        require("./images/pediatricPatient/1350_Cart_Medical_thanksPopup.png"),
      ],
      gift_shop: [
        require("./images/pediatricPatient/1350_ItemSelection_GiftShop_step1.png"),
        require("./images/pediatricPatient/1350_ItemSelection_GiftShop_step2.png"),
        require("./images/pediatricPatient/1350_ItemSelection_GiftShop_step3.png"),
        require("./images/pediatricPatient/1350_ItemSelection_GiftShop_step4.png"),
        require("./images/pediatricPatient/1350_Cart_GiftShop_editHL.png"),
        require("./images/pediatricPatient/1350_Cart_GiftShop_editPopup.png"),
        require("./images/pediatricPatient/1350_Cart_GiftShop_purchaseHL.png"),
        require("./images/pediatricPatient/1350_Cart_GiftShop_thanksPopup.png"),
      ],
    },

    wrap: false,
    backRoute_gift_shop: "/retail_shopping/popup/gift_shop",
    backRoute_medical: "/retail_shopping/popup/medical",
    endRoute: "/retail_shopping/revenue_centers",
  };

  /**
   * The service's different screens
   */
  retailShoppingNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/retail_shopping",
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let slides = null;
    switch (this.state.currentPatient) {
      case "orthoPatient":
        slides = this.state.orthoPatient;
        break;
      case "chfPatient":
        slides = this.state.chfPatient;
        break;
      case "pediatricPatient":
        slides = this.state.pediatricPatient;
        break;
      default:
        slides = this.state.orthoPatient;
    }

    return (
      <div className="service-1350">
        <ImageBackground id="background" />
        <Switch>
          <Route
            path="/retail_shopping/revenue_centers"
            component={RevenueCenters}
          />
          <Route
            path="/retail_shopping/revenue_center/:name"
            render={(routeProps) => (
              <SlideShow
                {...routeProps}
                slides={slides[`${routeProps.match.params.name}`]}
                wrap={this.state.wrap}
                backRoute={
                  this.state[`backRoute_${routeProps.match.params.name}`]
                }
                endRoute={this.state.endRoute}
              />
            )}
          />
          <Route
            path="/retail_shopping/popup/:name"
            render={(props) => (
              <ShoppingPopup
                {...props}
                currentPatient={this.state.currentPatient}
              />
            )}
          />
          <Route
            path="/retail_shopping"
            render={() => <Redirect to="/retail_shopping/revenue_centers" />}
          />
        </Switch>
      </div>
    );
  }
}

const ConnectedService1350 = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Service1350);

export default withRouter(ConnectedService1350);
